/*
 * ATTENTION: The "eval" devtool has been used (maybe by default in mode: "development").
 * This devtool is neither made for production nor for readable output files.
 * It uses "eval()" calls to create a separate source file in the browser devtools.
 * If you are trying to read the output file, select a different devtool (https://webpack.js.org/configuration/devtool/)
 * or disable the default devtool with "devtool: false".
 * If you are looking for production-ready output files, see mode: "production" (https://webpack.js.org/configuration/mode/).
 */
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["easy-project-utils"] = factory();
	else
		root["easy-project-utils"] = factory();
})(this, function() {
return /******/ (function() { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./utils/highlightKeywords.js":
/*!************************************!*\
  !*** ./utils/highlightKeywords.js ***!
  \************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

eval("__webpack_require__.r(__webpack_exports__);\n/* harmony import */ var _isStringEmpty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./isStringEmpty */ \"./utils/isStringEmpty.js\");\n/**\r\n * 根据数组高亮搜索词，用法：v-html\r\n * <p v-html=\"highlightKeywords(’webpack详细的配置选项‘, ['webpack','配置'], '#008AFF')\"></p>\r\n * <p v-html=\"highlightKeywords(’webpack详细的配置选项‘, 'webpack', '#008AFF')\"></p>\r\n * @param val {string} 原始文本\r\n * @param keywords {string | array} 单个关键词字符串或字符串数组\r\n * @param color {string} 高亮颜色，默认值：'#008AFF'\r\n * @returns {string}\r\n */\r\n\r\n\r\nfunction highlightKeywords(val, keywords, color = '#FF4441') {\r\n    if ((0,_isStringEmpty__WEBPACK_IMPORTED_MODULE_0__[\"default\"])(val)) {\r\n        console.error('[easy-project-vue warn]:highlightKeywords方法的val必须是一个非空字符串！当前val:', val)\r\n        return ''\r\n    }\r\n\r\n\r\n    try {\r\n        let res = val\r\n        if (keywords && keywords.constructor === String) {\r\n            return res.replaceAll(keywords, `<span style=\"color:${color};\">${keywords}</span>`)\r\n        }\r\n\r\n        if (keywords instanceof Array) {\r\n            keywords.forEach(keyword => {\r\n                if (val) {\r\n                    res = res.replaceAll(keyword, `<span style=\"color:${color};\">${keyword}</span>`)\r\n                }\r\n            })\r\n            return res\r\n        }\r\n        return res\r\n    } catch (e) {\r\n        console.error('highlightKeywords.js [easy-project-vue error]:', e)\r\n        return val\r\n    }\r\n\r\n}\r\n\r\n/* harmony default export */ __webpack_exports__[\"default\"] = (highlightKeywords);\r\n\n\n//# sourceURL=webpack://easy-project-utils/./utils/highlightKeywords.js?");

/***/ }),

/***/ "./utils/isStringEmpty.js":
/*!********************************!*\
  !*** ./utils/isStringEmpty.js ***!
  \********************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

eval("__webpack_require__.r(__webpack_exports__);\n/**\r\n * @description: 判断字符串是否为空字符串（含空格）、null、undefined、或其他数据类型。\r\n * @param {*} str\r\n * @return {boolean}\r\n * @author: hekai\r\n */\r\nfunction isStringEmpty(str) {\r\n    if (str && str.constructor === String) {\r\n        return str === '' || str.trim().length === 0\r\n    }\r\n    //不为字符串则直接判断为空\r\n    return true\r\n}\r\n\r\n/* harmony default export */ __webpack_exports__[\"default\"] = (isStringEmpty);\r\n\n\n//# sourceURL=webpack://easy-project-utils/./utils/isStringEmpty.js?");

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	!function() {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = function(exports) {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	}();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module can't be inlined because the eval devtool is used.
/******/ 	var __webpack_exports__ = __webpack_require__("./utils/highlightKeywords.js");
/******/ 	
/******/ 	return __webpack_exports__;
/******/ })()
;
});